// 协议确认API接口

import { BaseApi, ApiResponse } from "../utils/request";
// 直接引具体 types 文件，避免 api → components/AgreementConfirmation barrel → AgreementConfirmation.tsx → api 的 3-node 环
import type { AgreementConfirmationConfig } from "../components/AgreementConfirmation/AgreementConfirmation.types";

/**
 * 协议确认API类
 */
export class AgreementConfirmationApi extends BaseApi {
  /**
   * 获取协议确认配置
   * @returns Promise<AgreementConfirmationConfig | null>
   */
  async getConfig(): Promise<AgreementConfirmationConfig | null> {
    const response = await this.get<
      ApiResponse<AgreementConfirmationConfig, true>
    >("/api/popup_agreement/config");
    return response.data.model || null;
  }
}

// 创建API实例
export const agreementConfirmationApi = new AgreementConfirmationApi();
